import { useState, useEffect, useMemo } from "react";
import moment from "moment";

const CountdownTimer = (props) => {
  const { time, complete, timeToShow, teamData, sessionData, type, currentRound } = props;
  const defaultMinutes = teamData?.is_game_complete === 1 ? 0 : Math.floor((timeToShow ?? 3615) / 60);
  const defaultSeconds = teamData?.is_game_complete === 1 ? 0 : (timeToShow ?? 3615) % 60;
  const [minutes, setMinutes] = useState(defaultMinutes);
  const [seconds, setSeconds] = useState(defaultSeconds);

  const staticDate = useMemo(() => {
    if (!time) return null;
    return moment.utc(time).add(sessionData?.total_pause_time || 0, "seconds");
  }, [time, sessionData?.total_pause_time]);

  const pause_date_time = sessionData?.pause_date_time;

  // Check session date is today date then time is working
  const isToday = useMemo(() => {
    if (!sessionData?.session_date) return false;
    const sessionDate = moment(sessionData.session_date);
    const currentDate = moment();
    return sessionDate.isSame(currentDate, "day");
  }, [sessionData?.session_date]);

  useEffect(() => {
    let timerInterval;
    const updateTimer = async () => {
      if (complete) {
        clearInterval(timerInterval);
        setMinutes(0);
        setSeconds(0);
        return;
      } else if (!complete && time && staticDate) {
        const now = moment();
        const total = Math.floor(
          Math.max(
            0,
            timeToShow - moment.duration(now.diff(staticDate)).asSeconds()
          )
        );
        const minutesLeft = Math.floor(total / 60);
        const secondsLeft = Math.floor(total % 60);
        setMinutes(minutesLeft);
        setSeconds(secondsLeft);
        if (total === 0) {
          clearInterval(timerInterval);
        }
      }
    };
    if (pause_date_time && teamData?.is_game_complete !== 1 && staticDate) {
      const total = Math.floor(
        Math.max(
          0,
          timeToShow -
            moment
              .duration(moment(pause_date_time).diff(staticDate))
              .asSeconds()
        )
      );
      const minutesLeft = Math.floor(total / 60);
      const secondsLeft = Math.floor(total % 60);

      setMinutes(minutesLeft);
      setSeconds(secondsLeft);
    } else if (isToday && time) {
      updateTimer();
      timerInterval = setInterval(updateTimer, 1000);
    }
    return () => {
      clearInterval(timerInterval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [complete, isToday, pause_date_time, time, timeToShow, teamData?.is_game_complete, staticDate]);

  const message = () => {
    return (
      <p>
        {timeToShow === 615 ? " (" : ""}
        {`${String(minutes).padStart(2, "0")}:${String(seconds).padStart(
         2,
         "0"
       )}`}
       {timeToShow === 615 ? ") " : ""}
     </p>
   )
 }

  return (
    <div>
      {teamData?.current_status > 3 || type === "is_button" ? (
        message()
      ) : currentRound > 0 ? message() : (
        "-"
      )}
    </div>
  );
};

export default CountdownTimer;
